import { render, staticRenderFns } from "./FAQGiftersComponent.vue?vue&type=template&id=774121ec&scoped=true&"
import script from "./FAQGiftersComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQGiftersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQGiftersComponent.vue?vue&type=style&index=0&id=774121ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774121ec",
  null
  
)

export default component.exports